<template>
    <div v-if="integrated">
        <card class="cursor-pointer mb-2 h-100" @click.native="open()">
            <div class="p-3">
                <img class="d-block m-auto" src="/img/foreup-logo.png" style="max-height: 60px;" />
            </div>
            <card-body class="pt-0 px-3 pb-3 text-center">
                <small>
                    <strong class="ml-1">
                        {{ integration.foreup_credential.course_name }}
                    </strong>
                    <br/>
                    <em class="ml-1">
                        {{ integration.foreup_credential.course_city }},
                        {{ integration.foreup_credential.course_state }}
                    </em>
                    <br/>
                    <strong class="mr-1">
                        Campaign:
                    </strong>{{ campaign ? campaign.name : '-' }}
                </small>
            </card-body>
        </card>

        <modal
            ref="modal"
            :has-footer="false"
            @hide="close()">
            <template slot="title">ForeUp Integration</template>

            <div>
                <h4 class="mb-3 text-center">
                    Please select the campaign to setup the ForeUp integration.
                </h4>
                <div class="form-group">
                    <label>Course</label>
                    <p>{{ integration.foreup_credential.course_name }}</p>
                </div>
                <div class="form-group">
                    <label>Select Campaign</label>
                    <select class="form-control" v-model="form.campaign_id"
                        :class="{'is-invalid': form.errors.has('campaign_id')}">
                        <option v-for="campaign of integration.campaigns"
                            :key="campaign.id"
                            :value="campaign.id">
                            {{ campaign.name }}
                        </option>
                    </select>
                    <div class="invalid-feedback" v-if="form.errors.has('campaign_id')">
                        {{ form.errors.get('campaign_id') }}
                    </div>
                    <div class="form-text" v-if="!form.errors.any()">
                        This is the campaign for the invites that will be sent.
                    </div>
                </div>
                <div class="modal-footer mt-2 pr-0 pb-0 pl-0">
                    <button type="button" class="btn btn-default" @click="closeEdit()">
                        Cancel
                    </button>
                    <button-loading type="button" class="btn btn-primary ml-2"
                        :loading="form.submitting"
                        @click="save">
                        Save
                    </button-loading>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
    import Form from "../../../utils/Form";

    export default {
        props: ['integration'],

        data() {
            return {
                form: new Form(),
            }
        },

        watch: {
            integration: {
                immediate: true,
                handler() {
                    if (this.integration && this.integration.foreup_credential) {
                        this.form = new Form({
                            location_id: this.integration.id,
                            campaign_id: this.integration.foreup_credential.campaign_id,
                        });
                        return;
                    }

                    this.form = new Form();
                }
            }
        },

        computed: {
            integrated() {
                return !!this.integration && !!this.integration.foreup_credential;
            },

            campaign() {
                return this.integration.campaigns.find(c => c.id === this.form.campaign_id);
            },
        },

        methods: {
            open() {
                this.$refs.modal.open();
                this.$emit('show', true);                
            },

            close() {                
                this.$emit('hide');
            },

            closeEdit() {
                this.$refs.modal.close();
            },

            save() {
                return this.form.put(this.$laroute.route('location-foreup-credential.update', {
                    location: this.form.location_id
                }))
                .then(({data}) => {                    
                    swal.fire({
                        title: 'Location Saved!',
                        type: 'success',
                    }).then(() => {
                        this.closeEdit();
                        this.$emit('save-integration', data.id);
                    });
                })
                .catch(error => console.error(error));
            }
        }
    }
</script>
